<template>
  <div class="userPage" :style="`background: #2A79FF url(${systemBgUrl}) no-repeat;background-size: cover;`">
    <div class="wrap">
      <div class="sysName">
        <div class="img">
          <img v-if="schoolLogo" :src="schoolLogo" alt="" />
        </div>
        <div class="line" v-if="schoolLogo"></div>
        <div class="name">{{systemName}}</div>
      </div>
      <div class="forgot con">
        <h3>找回密码</h3>
        <div class="form">
          <a-form
              id="formForgot"
              :form="form"
              ref="formForgot"
              @submit="handleSubmit"
            >
            <div class="container">
              <input style="opacity: 0;position:absolute;width:0;height:0;">
              <input type="password" style="opacity: 0;position:absolute;width:0;height:0;">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="手机号">
                    <a-input
                      class="cus-input"
                      type="text"
                      :maxLength=11
                      placeholder="请输入手机号"
                      v-decorator="[
                        'loginname',
                        {
                          rules: [{ required: true, message: '请输入手机号' }],
                          validateTrigger: 'change',
                        },
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="验证码">
                    <a-input
                      class="cus-input"
                      type="text"
                      placeholder="请输入验证码"
                      v-decorator="[
                        'vcode',
                        {
                          rules: [{ required: true, message: '请输入验证码' }],
                          validateTrigger: 'change',
                        },
                      ]"
                    >
                      <a-button type="link" class="codeBtn" slot="addonAfter" :disabled="codeDisabled" @click="sendCode">{{btnText}}</a-button>
                    </a-input>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="密码">
                    <a-input
                      class="cus-input"
                      type="password"
                      autocomplete="false"
                      placeholder="请输入密码"
                      @focus="diserror"
                      v-decorator="[
                        'password',
                        {
                          rules: [{ required: true, message: '请输入密码' }],
                          validateTrigger: 'change',
                        },
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="确认密码">
                    <a-input
                      class="cus-input"
                      type="password"
                      autocomplete="false"
                      placeholder="请再次输入密码"
                      @focus="diserror"
                      v-decorator="[
                        'psdAgain',
                        {
                          rules: [{ required: true, message: '请再次输入密码' }],
                          validateTrigger: 'change',
                        },
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col>
              </a-row>

              <div class="tip">{{tip}}</div>

              <a-form-item style="text-align:center;margin-bottom:14px;">
                <a-button
                  type="primary"
                  size="large"
                  block
                  htmlType="submit"
                  class="action-button"
                  >确认找回</a-button
                >
              </a-form-item>

              <div style="text-align:center;text-decoration: underline">
                <a @click="toLogin">直接登录</a>
              </div>

            </div>
          </a-form>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { forgotPwd, forgotCode, forgotPwdRule } from '@/api/api';
import { telValid } from '@/utils/reg.js'


export default {
  name: "Forgot",
  data() {
    return {
      form: this.$form.createForm(this),
      btnText: '获取验证码',
      codeDisabled: false,
      rule: '',
      tip: '',
      prompt: '',
      phone: '',
      systemBgUrl: require('@/assets/pcStu.png'),
      systemName: localStorage.getItem('systemName'),
      schoolLogo: localStorage.getItem('schoolLogo')
    };
  },
  methods: {
    toLogin() {
      this.$router.push({
        name: "Login",
        query: {
          uvCode: localStorage.getItem("uvCode")
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if(values.password){
          const regPwd = eval(`/${this.rule}/`);
          if (!regPwd.test(values.password)) {
            this.$message.error({
              content: this.prompt,
            });
            return;
          }
        }
        if(values.psdAgain){
          if (values.psdAgain != values.password) {
            this.$message.error('两次输入密码不一致，请重新输入！');
            return;
          }
        }
        if (!err) {
          forgotPwd({
            loginname: values.loginname.trim(),
            vcode: values.vcode.trim(),
            pwdNew: values.password.trim()
          }).then(res => {
            if (res.code == 0) {
              this.form.resetFields();
              this.$message.success(res.msg)
              const uvCode = localStorage.getItem("uvCode")
              setTimeout(() => {
                this.$router.push({
                  name: "Login",
                  query: {
                    uvCode: uvCode
                  }
                });
              }, 1000)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      });
    },
    // 发送验证码
    sendCode() {
      this.phone = this.form.getFieldValue('loginname')
      if (!this.phone) {
        this.$message.error('请填写手机号');
        return;
      } else {
        if (!telValid(this.phone.trim())) {
          this.$message.error('请填写正确格式的手机号码');
          return;
        }
      }
      this.codeDisabled = true;
      forgotCode({
        phone: this.phone,
      }).then(res => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          var time = 60    // 定义60秒的倒计时
          const _this = this
          var codeV = setInterval(function () {
            _this.btnText = `重新获取${--time}s`;
            if (time == -1) {  // 清除setInterval倒计时，按钮变回原样
              clearInterval(codeV);
              _this.codeDisabled = false;
              _this.btnText = '获取验证码';
            }
          }, 1000)
          this.getPwdRule()
        } else {
          this.codeDisabled = false;
          this.$message.error(res.msg);
        }
      })
    },
    // 获取密码规则
    getPwdRule () {
      this.phone = this.form.getFieldValue('loginname')
      if (!this.phone) {
        this.$message.error('请填写手机号');
        return;
      } else {
        if (!telValid(this.phone.trim())) {
          this.$message.error('请填写正确格式的手机号码');
          return;
        }
      }
      forgotPwdRule({
        phone: this.phone
      }).then(res => {
        if (res.data) {
          this.rule = res.data.regular;
          this.tip = res.data.pwdZcText;
          this.prompt = res.data.prompt;
        }
      })
    },
    diserror() {
      this.psdError = false;
      if (!this.rule) {
        this.getPwdRule()
      }
    },
  },
  mounted() {
    this.form.resetFields();
  },
};
</script>

<style lang="less" scoped>
.userPage {
  // background: url(~@/assets/pcStu.png) no-repeat;
  background-size: cover !important;
  min-height: 100%;
  width: 100%;
}
/deep/ .ant-input-group-addon{
  background-color: #fff;
}
.codeBtn{
  padding: 0 4px;
  background-color: #fff;
  height: 30px;
}
.wrap {
  width: 876px;
  margin: 0px auto;
  padding-bottom: 32px;
  .sysName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 110px 0 52px;
    text-align: center;
    img{
      height: 67px;
    }
    .line{
      width: 1px;
      height: 36px;
      border-right: 1px solid rgba(255, 255, 255, 0.6);
      margin: 0px 20px;
    }
    .name{
      font-size: 40px;
      color: #FFFFFF;
    }
  }
  .con {
    width: 876px;
    min-height: 468px;
    background: #fff;
    border-radius: 8px;
    padding: 58px 56px;
    h3{
      font-size: 24px;
      color: #000;
      margin-bottom: 38px;
    }
    .form{
      padding: 0px 56px;
    }
  }
}
.action-button{
  width: 325px;
  margin: 32px auto 0;
}
.tip{
  font-size: 12px;
  color: #FF4747;
}
</style>